// src/pages/admin/bookings/components/BookingStatusChip.tsx

import * as React from "react";
import { Chip, Tooltip } from "@mui/material";
import type { BookingStatus } from "../bookingTypes";
import { safeStr } from "../bookingTypes";

function statusToColor(status?: BookingStatus | null):
    | "default"
    | "primary"
    | "secondary"
    | "success"
    | "warning"
    | "error"
    | "info" {
    const s = (status || "").toString().toLowerCase();
    if (s === "confirmed") return "success";
    if (s === "hold" || s === "pending") return "warning";
    if (s === "cancelled") return "error";
    if (s === "checked_in") return "info";
    if (s === "checked_out") return "secondary";
    if (s === "new") return "primary";
    if (s === "archived") return "default";
    return "default";
}

function statusLabel(status?: BookingStatus | null): string {
    const s = safeStr(status, "unknown").trim();
    if (!s) return "unknown";
    return s
        .split("_").join(" ")
        .split(" ")
        .map((w) => (w ? w[0].toUpperCase() + w.slice(1) : w))
        .join(" ");
}

export default function BookingStatusChip({
    status,
    size = "small",
    variant = "filled",
}: {
    status?: BookingStatus | null;
    size?: "small" | "medium";
    variant?: "filled" | "outlined";
}) {
    const label = statusLabel(status);
    const color = statusToColor(status);
    return (
        <Tooltip title={`Status: ${label}`}>
            <Chip
                size={size}
                variant={variant}
                color={color}
                label={label}
                sx={{
                    fontWeight: 700,
                    letterSpacing: 0.2,
                    borderRadius: 999,
                }}
            />
        </Tooltip>
    );
}
